import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d25b33b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d25b33b2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25b33b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d25b33b2')) {
      api.createRecord('d25b33b2', component.options)
    } else {
      api.reload('d25b33b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d25b33b2&scoped=true", function () {
      api.rerender('d25b33b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/discount/index.vue"
export default component.exports